export enum State {
  Login = 'login',
  Main = 'main',
  AttemptToOpenSR = 'attemptToOpenSR',
}
